// src/hooks/useInventory.js
// Gère houses/{houseId}/inventory
import { useState, useEffect, useCallback } from 'react';
import {
  subscribeInventory,
  addItem,
  updateItem,
  deleteItem,
} from '../lib/firebase';

export function useInventory(houseId) {
  const [inventory, setInventory] = useState([]);
  const [loading,   setLoading]   = useState(true);

  useEffect(() => {
    if (!houseId) { setInventory([]); setLoading(false); return; }
    setLoading(true);
    const unsub = subscribeInventory(houseId, items => {
      setInventory(items);
      setLoading(false);
    });
    return unsub;
  }, [houseId]);

  const add = useCallback(async (data) => {
    if (!houseId) return;
    await addItem(houseId, data);
  }, [houseId]);

  const update = useCallback(async (itemId, data) => {
    if (!houseId) return;
    await updateItem(houseId, itemId, data);
  }, [houseId]);

  const remove = useCallback(async (itemId) => {
    if (!houseId) return;
    await deleteItem(houseId, itemId);
  }, [houseId]);

  const changeQty = useCallback(async (itemId, delta) => {
    if (!houseId) return;
    const item = inventory.find(i => i.id === itemId);
    if (!item) return;
    const newQty = Math.max(0, (item.qty || 1) + delta);
    if (newQty === 0) return null; // signal → confirmer suppression
    await updateItem(houseId, itemId, { qty: newQty });
    return newQty;
  }, [houseId, inventory]);

  return { inventory, loading, add, update, remove, changeQty };
}
